import styled from "styled-components";

const Container = styled.div`
  background-color: #fff;
  box-shadow: rgba(145, 158, 171, 0.2) 0px 0px 2px 0px,
    rgba(145, 158, 171, 0.12) 0px 12px 24px -4px;
  border-radius: 16px;
  margin: 2%;
  position: relative;
  width: 90%;
  height: 100%;
  max-height:290px;
  cursor: pointer;
    .card-container {
       color: #fff;
       position:relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .options-container{
        position: absolute;
        top: 70%;
        right: 5px;
        font-weight: 700;
        z-index: 9;
        cursor: pointer;
        text-align: right;
        border-radius: 24px;
        .menu {
          font-size: 30px;
          margin: 0;
          color:#000;
        }
        .options {
          margin: 0;
          list-style: none;
          text-align: left;
          flex-direction: column;
          border: 1px solid #ed4242;
          border-radius: 24px;
          padding: 1rem;
          color: #000;
          background: #fff;
          visibility: hidden;
          opacity: 0;
          transition: visibility 200ms, opacity 200ms, display 200ms;
          .delete {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
              color: red;
            }
          }
          .edit {
            display: flex;
            justify-content: space-between;
            align-items: center;
            img {
              width: 20px;
            }
          }
          &.active {
            display: flex;
            visibility: visible;
            opacity: 1;
            transition: visibility 200ms, opacity 200ms, display 200ms;
          }
          li {
            font-size: 16px;
            a {
              text-decoration: none;
              color: #000;
            }
          }
        }
        }
      .data-container {
           width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 70%;
        }
        h2 {
          padding: 6%;
          display: flex;
          color: #9094a2;
          margin: 0;
        }
      }
    }
    .product-grid--wrap::-webkit-scrollbar {
      display: none;
    }
    .product-grid--wrap::-webkit-scrollbar-thumb {
      display: none;
    }
    @media only screen and (min-width: 867px) {
      img {
        width: 100%;
        height: 70%;
      }
    }
  }
  .trash-can-button {
    stroke: red;
    width: 20px;
    background: none;
    border: none;
    z-index: 2;
    opacity: 1;
    cursor: pointer;
    .trash-can-icon {
      width: 100%;
    }
    @media only screen and (min-width: 867px) {
      width: 20px;
      top: 10px;
      right: 10px;
    }
  }
  @media only screen and (min-width: 867px) {
    height: 97%;
  }
`;

export { Container };
